// Generated by scripts/generateTimeBasedGames.js — do not edit by hand.
// Source: Redash "Installed Games on Users' PCs (60D)" export, 2026-09-15.
//
// The count is NOT an audience size. It comes from INSTALLED_GAMES_DETECTED, which is emitted once
// per account per change to its install set, only in whitelisted countries, after sampling — so it
// is "accounts whose library changed in the window and were sampled", not machines. Overwolf also
// resolves some titles off a shared launcher registry key, so a variant can inherit its sibling's
// installs. A row is only flagged when its executable set AND its install key (launcher registry
// key, -applaunch id, install hint) are identical to a sibling's, which is what the census resolves
// on — today exactly the VALORANT/PBE and TFT/PBE pairs. Flagged rows carry no count and are listed
// after the ranked ones. Treat the order as a rough popularity hint, never as reach.
//
// Nothing an Overwolf id names is hidden. A row that may not deliver carries a note instead, and
// the picker shows it: the client gates by title, so an Overwolf id whose title Buff supports with
// in-game events never reaches the session path. Excluded only: Buff's own event-based game ids,
// which belong in the Games field, and titles under 50 installs.
// 1249 games, 1 marked title-gated, 2 marked unverified.

/** `[Overwolf class id, title, reported installs or null, caution to show beside it]` */
export type TimeBasedGameEntry = [string, string, number | null, string | null]

export const TIME_BASED_GAMES: TimeBasedGameEntry[] = [
  ["22176", "Minecraft Bedrock", 13128, null],
  ["21302", "Geometry Dash", 9040, null],
  ["6738", "Terraria", 8571, null],
  ["21796", "Aim Lab", 7899, null],
  ["28020", "MECCHA CHAMELEON", 7667, null],
  ["10868", "Dead By Daylight", 6884, null],
  ["25610", "Schedule I", 5736, null],
  ["23522", "Lethal Company", 5656, null],
  ["1406", "Garry's Mod", 5580, null],
  ["25482", "GTA V Enhanced", 5371, null],
  ["21652", "Among Us", 5305, null],
  ["5594", "Left 4 Dead 2", 5005, null],
  ["21892", "Bloons TD 6", 4466, null],
  ["10760", "Grand Theft Auto V", 4426, null],
  ["8954", "Warframe", 4272, null],
  ["10156", "Rust", 4188, null],
  ["27908", "Gamble With Your Friends", 3943, null],
  ["24110", "Content Warning", 3789, null],
  ["3026", "Team Fortress 2", 3647, null],
  ["27936", "Subnautica 2", 3287, null],
  ["21446", "Subnautica", 3139, null],
  ["23478", "The Finals", 3139, null],
  ["10598", "Project Zomboid", 3109, null],
  ["24000", "HELLDIVERS 2", 3108, null],
  ["10540", "The Sims 4", 3000, null],
  ["22048", "VRChat", 2972, null],
  ["10778", "ARK: Survival Evolved", 2931, null],
  ["28182", "How to Fish", 2878, null],
  ["21334", "Raft", 2870, null],
  ["21408", "The Forest", 2794, null],
  ["19054", "Stardew Valley", 2777, null],
  ["21658", "Phasmophobia", 2760, null],
  ["21866", "ELDEN RING", 2751, null],
  ["10470", "Unturned", 2746, null],
  ["26980", "EA SPORTS FC 26", 2666, null],
  ["26462", "Battlefield 6", 2630, null],
  ["27304", "Where Winds Meet", 2629, null],
  ["22576", "FiveM", 2613, null],
  ["10810", "Call of Duty: Black Ops III", 2584, null],
  ["23770", "One-Armed Robber", 2515, null],
  ["22302", "Escape the Backrooms", 2454, null],
  ["22638", "Sons of the Forest", 2352, null],
  ["22600", "Hogwarts Legacy", 2344, null],
  ["21784", "Sea of Thieves", 2342, null],
  ["6670", "Portal 2", 2273, null],
  ["21794", "Muck", 2229, null],
  ["24482", "Deadlock", 2219, null],
  ["10886", "The Elder Scrolls V: Skyrim Special Edition", 2212, null],
  ["9714", "7 Days to Die", 2192, null],
  ["11820", "BeamNG.drive", 2116, null],
  ["26770", "Hollow Knight: Silksong", 2092, null],
  ["21812", "Destiny 2", 2079, null],
  ["22052", "Ready Or Not", 2065, null],
  ["27962", "Forza Horizon 6", 2043, null],
  ["22522", "FPS Chess", 2027, null],
  ["21332", "House Flipper", 2020, null],
  ["21592", "Risk of Rain 2", 2007, null],
  ["24884", "Delta Force", 1983, null],
  ["24364", "Zenless Zone Zero", 1947, null],
  ["3683", "Osu!", 1928, null],
  ["10654", "The Binding of Isaac: Rebirth", 1926, null],
  ["10703", "Dying Light", 1880, null],
  ["25504", "FragPunk", 1877, null],
  ["27190", "RV There Yet?", 1871, null],
  ["9126", "War Thunder", 1864, null],
  ["22088", "Baldur's Gate III", 1860, null],
  ["24112", "Buckshot Roulette", 1859, null],
  ["21204", "Hollow Knight", 1805, null],
  ["21668", "Valheim", 1783, null],
  ["20450", "Undertale", 1780, null],
  ["22396", "ROUNDS", 1742, null],
  ["25960", "Deltarune", 1709, null],
  ["22076", "Forza Horizon 5", 1705, null],
  ["8680", "Castle Crashers", 1692, null],
  ["22182", "ULTRAKILL", 1678, null],
  ["24626", "TCG Card Shop Simulator", 1655, null],
  ["26734", "Osu! (Lazer)", 1653, null],
  ["21392", "No Man's Sky", 1649, null],
  ["21314", "Cuphead", 1641, null],
  ["22150", "People Playground", 1614, null],
  ["24096", "Balatro", 1608, null],
  ["22148", "Stumble Guys", 1596, null],
  ["22328", "Call of Duty: Modern Warfare II", 1562, null],
  ["22058", "Totally Accurate Battle Simulator", 1499, null],
  ["10772", "The Witcher 3: Wild Hunt", 1486, null],
  ["22092", "Goose Goose Duck", 1475, null],
  ["8448", "Borderlands 2", 1457, null],
  ["10836", "Fallout 4", 1457, null],
  ["26926", "Megabonk", 1424, null],
  ["23010", "The Hunter: Call of the Wild", 1419, null],
  ["24342", "Chained Together", 1405, null],
  ["21470", "Overcooked! 2", 1393, null],
  ["22532", "Golf With Your Friends", 1338, null],
  ["23476", "ARK: Survival Ascended", 1329, null],
  ["959", "Counter-Strike 1.6", 1308, null],
  ["21624", "Red Dead Redemption 2", 1306, null],
  ["24026", "Supermarket Simulator", 1301, null],
  ["21596", "SCP: Secret Laboratory", 1293, null],
  ["3080", "Portal", 1286, null],
  ["26298", "Umamusume: Pretty Derby", 1258, null],
  ["24624", "Liar's Bar", 1257, null],
  ["21664", "Cyberpunk 2077", 1245, null],
  ["21646", "Satisfactory", 1225, null],
  ["26970", "CloverPit", 1223, null],
  ["27858", "Slay The Spire 2", 1213, null],
  ["24132", "RAID: Shadow Legends", 1211, null],
  ["10898", "For Honor", 1207, null],
  ["25280", "Marvel's Spider-Man 2", 1184, null],
  ["6355", "Fallout: New Vegas", 1177, null],
  ["24300", "Wuthering Waves", 1161, null],
  ["22858", "The Outlast Trials", 1153, null],
  ["9694", "PAYDAY 2", 1147, null],
  ["21350", "Totally Accurate Battlegrounds", 1130, null],
  ["22804", "Honkai: Star Rail", 1125, null],
  ["23648", "Bopl Battle", 1123, null],
  ["23006", "Ultimate Custom Night", 1121, null],
  ["14422", "Gang Beasts", 1115, null],
  ["22164", "Marvel's Spider-Man Remastered", 1115, null],
  ["21880", "Yu-Gi-Oh! Master Duel", 1104, null],
  ["25692", "BLOODSTRIKE", 1103, null],
  ["22420", "PROJECT PLAYTIME", 1100, null],
  ["17344", "Plants vs Zombies: Garden Warfare 2", 1092, null],
  ["26398", "Mage Arena", 1090, null],
  ["22700", "Diablo IV", 1086, null],
  ["23354", "Party Animals", 1080, null],
  ["22584", "Dark and Darker", 1061, null],
  ["27870", "Super Battle Golf", 1059, null],
  ["22104", "Multiversus", 1054, null],
  ["18690", "Slime Rancher", 1048, null],
  ["14156", "Fishing Planet", 1047, null],
  ["23186", "Palia", 1040, null],
  ["26790", "NBA 2K26", 1031, null],
  ["765", "World of Warcraft", 1029, null],
  ["22204", "One-Armed Cook", 1022, null],
  ["21386", "Fallout Shelter", 1010, null],
  ["22102", "Powerwash Simulator", 1009, null],
  ["22236", "Teardown", 1004, null],
  ["22284", "Stick Fight: The Game", 1002, null],
  ["17846", "Rec Room", 999, null],
  ["22318", "Deep Rock Galactic", 994, null],
  ["21912", "Hitman 3", 994, null],
  ["25446", "Monster Hunter Wilds", 976, null],
  ["8584", "Euro Truck Simulator 2", 973, null],
  ["22282", "Brotato", 968, null],
  ["7212", "Path of Exile", 963, null],
  ["21674", "Hades", 949, null],
  ["25918", "ELDEN RING NIGHTREIGN", 937, null],
  ["22072", "Minecraft Dungeons", 921, null],
  ["23368", "My Hero Ultra Rumble", 910, null],
  ["10882", "Sid Meier's Civilization VI", 910, null],
  ["8671", "Call of Duty: Black Ops II Zombies", 903, null],
  ["27854", "Resident Evil Requiem", 900, null],
  ["24548", "Warhammer 40000 Space Marine 2", 899, null],
  ["27170", "Dispatch", 892, null],
  ["21414", "MONSTER HUNTER: WORLD", 891, null],
  ["10780", "Batman: Arkham Knight", 882, null],
  ["27866", "Scritchy Scratchy", 871, null],
  ["24886", "Path of Exile 2", 864, null],
  ["24244", "Ghost of Tsushima: Director's Cut", 861, null],
  ["8668", "Call of Duty: Black Ops II", 858, null],
  ["26652", "Waterpark Simulator", 858, null],
  ["10114", "DayZ", 855, null],
  ["22542", "Wolfenstein: Enemy Territory", 855, null],
  ["21268", "Slay The Spire", 845, null],
  ["22354", "My Singing Monsters", 843, null],
  ["24360", "The First Descendant", 843, null],
  ["24362", "Stardew Valley Modded", 834, null],
  ["22156", "Cult of the Lamb", 833, null],
  ["21894", "Borderlands 3", 825, null],
  ["22244", "Slime Rancher 2", 816, null],
  ["24302", "Bodycam", 803, null],
  ["6998", "Kerbal Space Program", 801, null],
  ["10874", "American Truck Simulator", 783, null],
  ["10850", "Dark Souls III", 781, null],
  ["27898", "Neverness To Everness", 778, null],
  ["24504", "Black Myth: Wukong", 776, null],
  ["22276", "Need for Speed: Heat", 776, null],
  ["22846", "Combat Master", 771, null],
  ["25884", "Splitgate 2", 763, null],
  ["27724", "Arknights: Endfield", 758, null],
  ["21790", "Halo: The Master chief Collection", 754, null],
  ["24608", "EA SPORTS FC 25", 747, null],
  ["23024", "A Dance of Fire and Ice", 745, null],
  ["22280", "Grounded", 740, null],
  ["8669", "Call of Duty: Black Ops II MP", 738, null],
  ["22922", "Ghost Recon: Breakpoint", 724, null],
  ["22252", "PlateUp!", 722, null],
  ["22662", "Limbus Company", 719, null],
  ["27850", "YAPYAP", 717, null],
  ["26874", "Borderlands 4", 715, null],
  ["22594", "Your only move is HUSTLE", 715, null],
  ["4499", "Grand Theft Auto IV", 714, null],
  ["10764", "AdVenture Capitalist", 712, null],
  ["5855", "StarCraft II", 699, null],
  ["23020", "The Isle", 698, null],
  ["21954", "Sekiro: Shadows Die Twice", 696, null],
  ["22358", "Spiderman: Miles Morales", 695, null],
  ["15148", "Human: Fall Flat", 691, null],
  ["14874", "Hearts of Iron IV", 690, null],
  ["5402", "Resident Evil 5", 687, null],
  ["21860", "Farming Simulator 22", 681, null],
  ["19358", "Tabletop Simulator", 678, null],
  ["22134", "Hell Let Loose", 674, null],
  ["23930", "Once Human", 673, null],
  ["23656", "The Last of Us: Part 1", 668, null],
  ["21426", "Dead Cells", 667, null],
  ["26840", "2XKO", 666, null],
  ["25724", "Clair Obscur: Expedition 33", 662, null],
  ["4436", "Left 4 Dead", 660, null],
  ["24812", "Farming Simulator 25", 649, null],
  ["22090", "God of War", 642, null],
  ["10890", "Factorio", 636, null],
  ["21394", "Moonlighter", 636, null],
  ["25484", "Split Fiction", 636, null],
  ["21418", "RimWorld", 635, null],
  ["22346", "Subnautica: Below Zero", 629, null],
  ["27232", "MIMESIS", 627, null],
  ["23946", "Enshrouded", 624, null],
  ["27618", "Hytale", 624, null],
  ["23312", "Assemble with care", 622, null],
  ["21254", "Far Cry 5", 617, null],
  ["22064", "Battlefield 2042", 613, null],
  ["21870", "Dying Light 2", 610, null],
  ["27610", "RageMP", 607, null],
  ["21424", "ASTRONEER", 606, null],
  ["22268", "The Planet Crafter", 605, null],
  ["10774", "Clicker Heroes", 603, null],
  ["10852", "DOOM", 602, null],
  ["27198", "PowerWash Simulator 2", 602, null],
  ["27996", "Green Hell", 599, null],
  ["28172", "Big Walk", 590, null],
  ["21678", "Resident Evil Village", 590, null],
  ["21208", "Albion Online", 585, null],
  ["21786", "STAR WARS Jedi: Fallen Order", 585, null],
  ["9208", "ARMA 3", 582, null],
  ["21914", "UNO", 582, null],
  ["23796", "Barony", 577, null],
  ["23034", "Car Mechanic 2021", 576, null],
  ["22350", "Gloomhaven", 573, null],
  ["21464", "Graveyard Keeper", 572, null],
  ["10904", "Ghost Recon: Wildlands", 569, null],
  ["9170", "Tomb Raider (2013)", 569, null],
  ["21782", "Chivalry 2", 567, null],
  ["24518", "Crime Scene Cleaner", 555, null],
  ["27914", "Librarian: Tidy Up the Arcane Library", 554, null],
  ["22784", "Getting Over It With Bennett Foddy", 553, null],
  ["24856", "Dark Hours", 548, null],
  ["24660", "DRAGON BALL: Sparking! ZERO", 546, null],
  ["27504", "Sky: Children of the Light", 546, null],
  ["10746", "World of Warships", 546, null],
  ["22326", "Hello Neighbor", 545, null],
  ["28018", "Burglin' Gnomes", 542, null],
  ["21634", "Escape From Tarkov", 542, null],
  ["27848", "Mewgenics", 542, null],
  ["25938", "F1 25", 537, null],
  ["23328", "ICARUS", 535, null],
  ["22524", "Freddy Fazbear's Pizzeria Simulator", 532, null],
  ["22704", "Contraband Police", 528, null],
  ["26382", "Grounded 2", 526, null],
  ["11014", "8Bit Fiesta", 525, null],
  ["25324", "A Game About Digging A Hole", 523, null],
  ["9802", "Outlast", 523, null],
  ["10706", "Cities: Skylines", 520, null],
  ["24554", "Lockdown Protocol", 520, null],
  ["21308", "Magic the Gathering: Arena", 520, null],
  ["22752", "Sifu", 519, null],
  ["21670", "World War Z", 518, null],
  ["24730", "Backrooms: Escape Together", 516, null],
  ["21594", "RuneScape", 513, null],
  ["21354", "Cuisine Royale", 506, null],
  ["21312", "DARK SOULS REMASTERED", 504, null],
  ["27856", "Marathon", 504, null],
  ["24216", "The Long Drive", 503, null],
  ["23108", "Wobbly Life", 501, null],
  ["10776", "Killing Floor 2", 497, null],
  ["21898", "Mortal Kombat 11", 497, null],
  ["22574", "Super Auto Pets", 496, null],
  ["24650", "WEBFISHING", 495, null],
  ["21942", "DOOM: Eternal", 489, null],
  ["23314", "Mortal Kombat 1", 488, null],
  ["21234", "Star Wars Battlefront II", 484, null],
  ["11570", "Assetto Corsa", 482, null],
  ["21614", "Celeste", 473, null],
  ["28000", "Roadside Research", 472, null],
  ["22526", "Trackmania 2020", 470, null],
  ["24282", "PANICORE", 468, null],
  ["22324", "Warhammer 40k: Darktide", 468, null],
  ["25914", "Guilty as Sock!", 467, null],
  ["21878", "Total War: WARHAMMER III", 466, null],
  ["24622", "God of War: Ragnarok", 463, null],
  ["25634", "Haste", 462, null],
  ["21328", "Hunt: Showdown", 458, null],
  ["26908", "No, I'm Not a Human", 454, null],
  ["22678", "Pummel Party", 453, null],
  ["25250", "SMITE 2", 453, null],
  ["23472", "Cities Skylines 2", 450, null],
  ["21916", "Planet Zoo", 445, null],
  ["22808", "Jedi Survivor", 444, null],
  ["24484", "Spectre Divide", 444, null],
  ["6369", "Call of Duty: Black Ops SP", 442, null],
  ["6350", "Final Fantasy XIV Online: A Realm Reborn", 442, null],
  ["21480", "Assassin's Creed: Odyssey", 438, null],
  ["21864", "Lost Ark", 437, null],
  ["25820", "DOOM: The Dark Ages", 436, null],
  ["27174", "DEVOUR", 435, null],
  ["22978", "Inscryption", 435, null],
  ["13442", "Dragon Ball Xenoverse 2", 431, null],
  ["23948", "TEKKEN 8", 430, null],
  ["21306", "A Way Out", 429, null],
  ["24866", "Dome Keeper", 429, null],
  ["27894", "Far Far West", 428, null],
  ["21660", "Rogue Company", 428, null],
  ["23830", "Bendy and the Ink Machine", 426, null],
  ["21992", "V Rising", 425, null],
  ["21246", "Warhammer: Vermintide 2", 424, null],
  ["24218", "Hades II", 421, null],
  ["21242", "Crossout", 419, null],
  ["23370", "FC 2024", 419, null],
  ["22146", "Leaf Blower Revolution", 415, null],
  ["24172", "Hydroneer", 412, null],
  ["22290", "GTFO", 410, null],
  ["22536", "State of Decay 2", 410, null],
  ["21266", "DRAGON BALL FighterZ", 406, null],
  ["22068", "Corekeeper", 404, null],
  ["8546", "Dishonored", 404, null],
  ["3542", "OldSchool RuneScape", 404, null],
  ["21874", "MONSTER HUNTER: RISE", 400, null],
  ["22848", "League of Legends PBE", 398, "shares League of Legends.exe with LoL (5426), so a launch may report the event-based id"],
  ["21630", "World of Warcraft Classic", 397, null],
  ["28146", "eFootball", 395, null],
  ["21798", "Forza Horizon 4", 395, null],
  ["27872", "Crimson Desert", 394, null],
  ["26928", "Dying Light: The Beast", 390, null],
  ["27958", "007 First Light", 389, null],
  ["22002", "Arma Reforger", 381, null],
  ["23002", "Farlight 84", 381, null],
  ["13760", "Enter the Gungeon", 380, null],
  ["25220", "MX Bikes", 379, null],
  ["25808", "Drive Beyond Horizons", 378, null],
  ["1340", "Grand Theft Auto: San Andreas Multiplayer", 377, null],
  ["25630", "The Last Of Us Part II Remastered", 377, null],
  ["22528", "Five Nights at Freddy's: Security Breach", 375, null],
  ["18366", "Scrap Mechanic", 375, null],
  ["26598", "Stick It to the Stickman", 375, null],
  ["22750", "DREDGE", 374, null],
  ["7152", "Diablo III", 373, null],
  ["27948", "Dead as Disco", 371, null],
  ["22106", "Stray", 371, null],
  ["22202", "Gunfire: Reborn", 370, null],
  ["24832", "Nuclear Nightmare", 369, null],
  ["4202", "Lego Batman", 367, null],
  ["9970", "LEGO Marvel Super Heroes", 367, null],
  ["24908", "Strinova", 367, null],
  ["25972", "Slapshot: Rebound", 366, null],
  ["23222", "Starfield", 365, null],
  ["22952", "Crab Champions", 363, null],
  ["22160", "Escape Simulator", 363, null],
  ["28134", "Assassin's Creed Black Flag Resynced", 362, null],
  ["23752", "House Flipper 2", 362, null],
  ["22262", "MARVEL SNAP", 362, null],
  ["21492", "WATCH_DOGS 2", 361, null],
  ["21482", "Planet Coaster", 360, null],
  ["6480", "theHunter", 355, null],
  ["6365", "World of Tanks / World Of Tanks", 355, null],
  ["10756", "Darkest Dungeon", 354, null],
  ["8766", "Sonic Adventure 2", 353, null],
  ["27242", "Jurassic World Evolution 3", 352, null],
  ["10284", "South Park: The Stick of Truth", 352, null],
  ["22056", "Back 4 Blood", 351, null],
  ["22032", "Crusader Kings III", 351, null],
  ["22184", "Mount & Blade II: Bannerlord", 351, null],
  ["10896", "World of Tanks Blitz", 351, null],
  ["22296", "DAVE the diver", 350, null],
  ["25276", "The Headliners", 350, null],
  ["21244", "Kingdom Come: Deliverance", 349, null],
  ["22766", "Demonologist", 348, null],
  ["22736", "A little to the Left", 347, null],
  ["22274", "Persona 5 Royal", 346, null],
  ["10730", "Life Is Strange", 344, null],
  ["24904", "Fast Food Simulator", 343, null],
  ["10860", "Stellaris", 343, null],
  ["24900", "MiSide", 342, null],
  ["27282", "DRAGON BALL: GEKISHIN SQUADRA", 340, null],
  ["22394", "Predecessor", 340, null],
  ["21220", "Middle-earth: Shadow of War", 339, null],
  ["27246", "Leaf It Alone", 338, null],
  ["22376", "Need for Speed: Unbound", 335, null],
  ["10744", "Besiege", 334, null],
  ["26218", "Mecha BREAK", 334, null],
  ["22038", "Unpacking", 334, null],
  ["22098", "The Crew 2", 332, null],
  ["27888", "PRAGMATA", 331, null],
  ["9682", "Papers; Please", 330, null],
  ["21604", "Super Animal Royale", 330, null],
  ["27886", "Windrose", 329, null],
  ["23064", "Brickrigs", 328, null],
  ["10714", "Hotline Miami 2: Wrong Number", 328, null],
  ["10762", "Mortal Kombat X", 328, null],
  ["21620", "Legends of Runeterra", 327, null],
  ["10634", "LEGO Batman 3: Beyond Gotham", 327, null],
  ["24796", "Microsoft Flight Simulator 2024", 327, null],
  ["23292", "HoloCure - Save the Fans!", 322, null],
  ["22082", "GUILTY GEAR -STRIVE-", 321, null],
  ["22618", "Stormworks", 320, null],
  ["21192", "TEKKEN 7", 320, null],
  ["22990", "Stacklands", 319, null],
  ["27902", "MOUSE: P.I For Hire", 317, null],
  ["25294", "Kingdom Come: Deliverance II", 316, null],
  ["8128", "LEGO Batman 2: DC Super Heroes", 316, null],
  ["10750", "TerraTech", 316, null],
  ["22764", "Garten of BanBan", 315, null],
  ["22890", "Electrician Simulator", 314, null],
  ["21432", "Laser League", 312, null],
  ["27966", "Scale the Depths", 312, null],
  ["24292", "Nine Sols", 311, null],
  ["10606", "Borderlands: The Pre-Sequel", 310, null],
  ["10610", "Alien: isolation", 309, null],
  ["26118", "Crime Simulator", 309, null],
  ["25264", "My Summer Car", 309, null],
  ["21462", "Shadow of the Tomb Raider", 308, null],
  ["10592", "Middle-earth: Shadow of Mordor", 307, null],
  ["23920", "Turmoil", 307, null],
  ["21316", "Squad", 306, null],
  ["24690", "THRONE AND LIBERTY", 305, null],
  ["10790", "The Long Dark", 304, null],
  ["22900", "Friends vs Friends", 303, null],
  ["25418", "Ranch Simulator", 303, null],
  ["21950", "Honkai Impact 3rd", 301, null],
  ["22314", "FIFA 23", 300, null],
  ["4592", "Wizard 101", 300, null],
  ["21546", "Firewatch", 299, null],
  ["24584", "NBA 2k25", 299, null],
  ["27920", "Pratfall", 299, null],
  ["23910", "Blasphemous", 298, null],
  ["9678", "DCS World", 298, null],
  ["27100", "Little Nightmares III", 296, null],
  ["22018", "Snow Runner", 295, null],
  ["21368", "Oxygen Not Included", 294, null],
  ["22854", "Far Cry 6", 293, null],
  ["10622", "Sleeping Dogs: Definitive Edition", 292, null],
  ["10846", "XCOM 2", 292, null],
  ["22538", "CarX Drift Racing Online", 291, null],
  ["27964", "Paralives", 291, null],
  ["22132", "Rain World", 288, null],
  ["23198", "Golf It!", 287, null],
  ["22070", "Barotrauma", 286, null],
  ["26572", "EA SPORTS Madden NFL 26", 286, null],
  ["25620", "inZOI", 286, null],
  ["24770", "Planet Coaster 2", 286, null],
  ["22946", "Riders Republic", 286, null],
  ["4157", "SPORE", 285, null],
  ["25580", "Assassin's Creed Shadows", 283, null],
  ["24318", "KINGDOM HEARTS -HD 1.5+2.5 ReMIX", 283, null],
  ["1079", "Eve Online", 281, null],
  ["27766", "Highguard", 280, null],
  ["27192", "MISERY", 280, null],
  ["22222", "Disney Dreamlight Valley", 279, null],
  ["21278", "NieR:Automata", 279, null],
  ["10128", "Starbound / Starbound (Beta)", 279, null],
  ["22564", "Dead Space", 278, null],
  ["22972", "Battle bit Remastered", 275, null],
  ["10376", "Goat Simulator", 275, null],
  ["6370", "Call of Duty: Black Ops MP", 274, null],
  ["21224", "Assassin's Creed: Origins", 273, null],
  ["23474", "Lords of the Fallen (2023)", 273, null],
  ["25646", "RuneScape: Dragonwilds", 273, null],
  ["22916", "Bread & Fred", 272, null],
  ["5387", "Batman: Arkham Asylum", 271, null],
  ["10110", "Elder Scrolls Online", 269, null],
  ["22566", "Pizza Tower", 269, null],
  ["10842", "Assassin's Creed: Syndicate", 268, null],
  ["22398", "High on Life", 267, null],
  ["28154", "We Were Here Together", 264, null],
  ["25792", "Deadzone Rogue", 263, null],
  ["21570", "Tom Clancy's The Division 2", 262, null],
  ["10758", "Black Mesa", 261, null],
  ["25684", "Aviassembly", 260, null],
  ["22348", "Bus Simulator 2021", 260, null],
  ["10880", "Titanfall 2", 260, null],
  ["22882", "Town of Salem 2", 260, null],
  ["6339", "Sid Meier's Civilization V", 258, null],
  ["21990", "Breathedge", 257, null],
  ["27256", "Football Manager 26", 256, null],
  ["22836", "Dead Island 2", 255, null],
  ["25686", "White Knuckle", 254, null],
  ["5558", "LEGO Star Wars: The Complete Saga", 253, null],
  ["22400", "Potion Craft", 252, null],
  ["23130", "Remnant 2", 252, null],
  ["1101", "Counter-Strike: Source", 250, null],
  ["21816", "New World", 249, null],
  ["27880", "Retro Rewind - Video Store Simulator", 247, null],
  ["24556", "Ale & Tale Tavern", 245, null],
  ["25782", "Dune: Awakening", 245, null],
  ["24384", "Ocean World: Eden Crafters Prologue", 245, null],
  ["24602", "Tiny Glade", 242, null],
  ["25958", "9 Kings", 241, null],
  ["6011", "Assassin's Creed II", 241, null],
  ["23398", "Assetto Corsa Competizione", 241, null],
  ["7364", "The Elder Scrolls V: Skyrim", 241, null],
  ["22158", "Tower of Fantasy", 241, null],
  ["24242", "Abiotic Factor", 240, null],
  ["21626", "Call of Duty: Modern Warfare", 239, null],
  ["21448", "Battlefield V", 237, null],
  ["27934", "RACCOIN: Coin Pusher Roguelike", 237, null],
  ["25002", "Schoolboy Runaway", 237, null],
  ["23798", "OPERATOR", 236, null],
  ["21436", "Two Point Hospital", 236, null],
  ["22796", "Disney Speedstorm", 235, null],
  ["22196", "Jojo's Bizzare Adventure: All Star Battle R", 235, null],
  ["24290", "Another Crab's Treasure", 234, null],
  ["27150", "BALL x PIT", 234, null],
  ["23794", "Lobotomy Corporation", 234, null],
  ["23096", "Viewfinder", 234, null],
  ["28196", "WARDOGS", 234, null],
  ["21272", "FrostPunk", 233, null],
  ["21230", "Call of Duty: WWII", 231, null],
  ["10754", "Dungeon Defenders II", 231, null],
  ["4331", "Fallout 3", 231, null],
  ["21982", "Bloodhunt", 230, null],
  ["21672", "Eternal Return: Black Survival", 230, null],
  ["21454", "Just Cause 3", 230, null],
  ["27950", "LEGO Batman: Legacy of the Dark Knight", 228, null],
  ["21852", "Microsoft Flight Simulator", 228, null],
  ["24176", "Manor Lords", 227, null],
  ["22780", "Minecraft Legends", 227, null],
  ["26850", "Shape of Dreams", 227, null],
  ["24960", "The Spell Brigade", 227, null],
  ["23248", "Gas Station Simulator", 226, null],
  ["18830", "Space Engineers", 226, null],
  ["24928", "Zort", 226, null],
  ["27810", "Berry Bury Berry", 225, null],
  ["5561", "Call of Duty: Modern Warfare 2 Singleplayer", 225, null],
  ["23812", "Escape from Tarkov: Arena", 225, null],
  ["21806", "Yu-Gi-Oh! Duel Links", 225, null],
  ["28032", "Fortune Mill", 224, null],
  ["21358", "Wreckfest", 221, null],
  ["23388", "Definitely Not Fried Chicken", 220, null],
  ["22026", "Horizon Zero Dawn", 219, null],
  ["10818", "METAL GEAR SOLID V: THE PHANTOM PAIN", 218, null],
  ["28010", "Pokemon TCG Live", 218, null],
  ["21884", "Age of Empires IV", 216, null],
  ["25758", "Among Us 3D", 216, null],
  ["10038", "Assassin's Creed IV: Black Flag", 215, null],
  ["25134", "PC Building Simulator", 215, null],
  ["26386", "Prison Escape Simulator: Dig Out", 213, null],
  ["7358", "Call of Duty: Modern Warfare 3 Single Player", 212, null],
  ["705", "Counter-Strike: Condition Zero", 212, null],
  ["22028", "Sniper Elite 5", 212, null],
  ["26052", "Stellar Blade", 212, null],
  ["26340", "Soulframe", 211, null],
  ["27106", "The Farmer Was Replaced", 210, null],
  ["8488", "PlanetSide 2", 209, null],
  ["3728", "Assassin's Creed", 208, null],
  ["24834", "CarX Street", 208, null],
  ["3755", "Trackmania Nations Forever", 208, null],
  ["23808", "BIGFOOT", 207, null],
  ["25694", "The Elder Scrolls IV: Oblivion Remastered", 207, null],
  ["28014", "Fears to Fathom - Scratch Creek", 206, null],
  ["22200", "Insurgency: Sandstorm", 206, null],
  ["24944", "Deep Rock Galactic: Survivor", 205, null],
  ["24818", "ATLYSS", 204, null],
  ["17924", "Resident Evil 0 Remaster", 204, null],
  ["22956", "Guardians of the Galaxy", 203, null],
  ["24014", "Timberborn", 203, null],
  ["25664", "Blue Prince", 200, null],
  ["22732", "Resident Evil 4", 200, null],
  ["12688", "Conan Exiles", 199, null],
  ["26428", "GONE Fishing", 199, null],
  ["27204", "Escape From Duckov", 198, null],
  ["23510", "For the King II", 198, null],
  ["27206", "Plants vs. Zombies: Replanted", 197, null],
  ["9756", "Total War: ROME II", 197, null],
  ["23274", "PAYDAY 3", 196, null],
  ["28068", "SAND: Raiders of Sophie", 196, null],
  ["27108", "Backseat Drivers", 194, null],
  ["21846", "Control", 194, null],
  ["24178", "Gray Zone Warfare", 194, null],
  ["27930", "Sledding Game", 194, null],
  ["26948", "Sonic Racing: CrossWorlds", 193, null],
  ["26334", "Summoners War", 193, null],
  ["23190", "Beyond: Two Souls", 192, null],
  ["26944", "Jump Space", 192, null],
  ["21788", "Noita", 192, null],
  ["23056", "Police Simulator: Patrol Officers", 192, null],
  ["21524", "Injustice 2", 191, null],
  ["22790", "Ravenswatch", 191, null],
  ["24644", "SILENT HILL 2 (2024)", 191, null],
  ["22722", "Sun Haven", 191, null],
  ["24846", "Vintage Story", 191, null],
  ["23104", "OMORI", 190, null],
  ["22316", "Krunker", 189, null],
  ["26320", "Off The Grid", 189, null],
  ["6448", "DC Universe Online", 188, null],
  ["21218", "Divinity: Original Sin 2", 188, null],
  ["26318", "Marvel Contest of Champions", 187, null],
  ["8838", "Don't Starve", 186, null],
  ["23124", "GoreBox", 186, null],
  ["27588", "StarRupture", 185, null],
  ["21926", "Age of Empires II: Definitive Edition", 184, null],
  ["22422", "SCP Labrat", 184, null],
  ["25514", "That's Not My Neighbor", 184, null],
  ["24170", "No Rest for the Wicked", 183, null],
  ["7412", "Star Wars: The Old Republic", 183, null],
  ["24964", "Kindergarten", 182, null],
  ["10814", "Mad Max", 182, null],
  ["23700", "Medieval Dynasty", 182, null],
  ["24260", "ROBOBEAT", 182, null],
  ["26068", "Five Nights at Freddy's: Secret of the Mimic", 181, null],
  ["27734", "LORT", 181, null],
  ["21590", "Mordhau", 181, null],
  ["23258", "Sunkenland", 181, null],
  ["10602", "The Evil Within", 181, null],
  ["3158", "The Witcher", 181, null],
  ["23842", "Torchlight: Infinite", 181, null],
  ["22660", "Dungeons of Aether", 178, null],
  ["6107", "Mount & Blade: Warband", 178, null],
  ["27812", "Scam Line", 178, null],
  ["5069", "The Sims 3", 178, null],
  ["22596", "BIT.TRIP RUNNER", 177, null],
  ["21844", "Humankind", 177, null],
  ["21344", "Jurassic World Evolution", 177, null],
  ["10884", "Call of Duty: Infinite Warfare", 176, null],
  ["6606", "Total War: SHOGUN 2", 176, null],
  ["22980", "Library of Ruina", 175, null],
  ["23462", "Thief Simulator 2", 175, null],
  ["22384", "Choo Choo Charles", 174, null],
  ["28200", "Halloween: The Game", 174, null],
  ["24074", "Horizon Forbidden West", 174, null],
  ["24662", "Storage Hunter", 174, null],
  ["6594", "Assassin's Creed: Brotherhood SP", 173, null],
  ["24286", "F1 24", 173, null],
  ["22272", "Gotham Knights", 173, null],
  ["23676", "Juice Galaxy", 173, null],
  ["22958", "Road 96", 173, null],
  ["22112", "SCP: Pandemic", 173, null],
  ["8134", "Smite", 173, null],
  ["22856", "VoidTrain", 173, null],
  ["22372", "Callisto Protocol", 172, null],
  ["27058", "Digimon Story Time Stranger", 172, null],
  ["21262", "Ori and the Blind Forest: Definitive Edition", 172, null],
  ["27750", "Gamblers Table", 171, null],
  ["10788", "LEGO Jurassic World", 171, null],
  ["22824", "Omega Strikers", 171, null],
  ["4997", "Killing Floor", 170, null],
  ["2684", "The Lord of the Rings Online", 169, null],
  ["9876", "Europa Universalis IV", 168, null],
  ["25942", "Trash Goblin", 167, null],
  ["7596", "Alan Wake", 166, null],
  ["21500", "Fallout 76", 166, null],
  ["24350", "Last Train Outta' Wormtown", 166, null],
  ["22232", "Need for Speed Payback", 166, null],
  ["24108", "Star Citizen", 165, null],
  ["22114", "The Quarry", 165, null],
  ["24572", "PICO PARK 2", 164, null],
  ["6792", "The Witcher 2: Assassins of Kings", 164, null],
  ["22642", "Atomic Heart", 163, null],
  ["10876", "Battlefield 1", 163, null],
  ["21540", "LEGO MARVEL's Avengers", 163, null],
  ["27424", "MineMogul", 163, null],
  ["21618", "Remnant:From the Ashes", 163, null],
  ["21938", "The Cycle", 163, null],
  ["27228", "VEIN", 163, null],
  ["21662", "Call of Duty Black Ops Cold War", 162, null],
  ["25784", "Cash Cleaner Simulator", 162, null],
  ["22362", "Construction Simulator", 161, null],
  ["24800", "Dokimon", 161, null],
  ["26478", "Is This Seat Taken?", 161, null],
  ["23778", "Placid Plastic Duck Simulator", 160, null],
  ["22122", "Dinkum", 159, null],
  ["23040", "Lies of P", 159, null],
  ["25922", "Wrap House Simulator", 159, null],
  ["15554", "Kenshi", 158, null],
  ["10848", "Tom Clancy's The Division", 158, null],
  ["23058", "Uncharted: Legacy of Thieves Collection", 158, null],
  ["24526", "Dale & Dawson Stationery Supplies", 157, null],
  ["24538", "Peglin", 157, null],
  ["26946", "SILENT HILL f", 157, null],
  ["1343", "Grand Theft Auto: San Andreas", 156, null],
  ["24782", "S.T.A.L.K.E.R II: Heart of Chernobyl", 156, null],
  ["7138", "Sonic Adventure DX", 156, null],
  ["24802", "Star Wars Outlaws", 156, null],
  ["28074", "The Seven Deadly Sins: Origin", 156, null],
  ["27300", "Ghost Janitors", 155, null],
  ["22994", "XDefiant", 154, null],
  ["21856", "Football Manager 2022", 153, null],
  ["25284", "Hello Kitty Island Adventure", 153, null],
  ["22304", "Sonic Frontiers", 153, null],
  ["24070", "Tainted Grail: The Fall of Avalon", 153, null],
  ["10734", "The Escapists", 153, null],
  ["24366", "Kill It With Fire 2", 152, null],
  ["7856", "Guild Wars 2", 151, null],
  ["21564", "HITMAN 2", 151, null],
  ["21324", "Realm Royale", 151, null],
  ["24820", "Heavy Rain", 150, null],
  ["23924", "Mon Bazou", 150, null],
  ["21226", "Prey", 149, null],
  ["24708", "SONIC X SHADOW GENERATIONS", 149, null],
  ["23848", "Escape Academy", 148, null],
  ["10854", "Total War: Warhammer", 148, null],
  ["27892", "Vampire Crawlers", 148, null],
  ["9527", "Company of Heroes 2", 147, null],
  ["22378", "Marvel's Midnight Sun", 147, null],
  ["10872", "Paladins", 147, null],
  ["25238", "Streamer Life Simulator 2", 147, null],
  ["25272", "Infinity Nikki", 146, null],
  ["5864", "Star Trek Online", 146, null],
  ["24646", "Path of Titans", 145, null],
  ["27238", "Escape Simulator 2", 144, null],
  ["22248", "Shatterline", 144, null],
  ["21318", "Starcraft REMASTERED", 144, null],
  ["24016", "Suicide Squad: Kill the Justice League", 144, null],
  ["21542", "Legion TD 2", 143, null],
  ["9176", "Surgeon Simulator 2013", 142, null],
  ["24438", "The Operator", 142, null],
  ["5564", "Call of Duty: Modern Warfare 2 Multiplayer", 141, null],
  ["24752", "Monster Hunter Wilds (Beta Test)", 141, null],
  ["21444", "SCUM", 141, null],
  ["24312", "Empires of the Undergrowth", 139, null],
  ["8636", "Need for Speed: Most Wanted (a Criterion game)", 139, null],
  ["23904", "A Plague Tale: Innocence", 138, null],
  ["21632", "Farming Simulator 19", 138, null],
  ["24340", "Murky Divers", 138, null],
  ["25318", "Sid Meier's Civilization VII", 138, null],
  ["22944", "20 Minutes till dawn", 137, null],
  ["8496", "FTL: Faster Than Light", 137, null],
  ["22172", "Backpack Hero", 136, null],
  ["27392", "DON'T SCREAM TOGETHER", 136, null],
  ["9505", "Resident Evil: Revelations", 136, null],
  ["23026", "Trepang2", 136, null],
  ["7438", "Assassin's Creed: Revelations", 135, null],
  ["22850", "Flashing Lights", 135, null],
  ["1190", "Half-Life 2: Deathmatch", 135, null],
  ["22598", "ANNO 1800", 134, null],
  ["22424", "Bendy and the Dark Revival", 134, null],
  ["25810", "Little Kitty, Big City", 134, null],
  ["28088", "Supermarket Chaos", 134, null],
  ["21800", "Assassin's Creed Valhalla", 133, null],
  ["23630", "Backpack Battles", 133, null],
  ["25188", "Ori and the Will of the Wisps", 133, null],
  ["23530", "Roboquest", 133, null],
  ["24056", "A Difficult Game About Climbing", 131, null],
  ["3176", "Call of Duty 4: Modern Warfare Single Player", 131, null],
  ["24076", "Dragon's Dogma 2", 131, null],
  ["22734", "Last Epoch", 131, null],
  ["22590", "Undisputed", 131, null],
  ["6450", "Dead Space 2", 130, null],
  ["22964", "Amnesia The Bunker", 129, null],
  ["10342", "Dark Souls II", 129, null],
  ["21442", "Far Cry Primal", 129, null],
  ["23032", "Isonzo", 129, null],
  ["24668", "Metaphor: ReFantazio", 129, null],
  ["24774", "SULFUR", 129, null],
  ["27546", "DEFRAG", 128, null],
  ["13370", "Dofus", 128, null],
  ["27916", "Everything Is Crab", 128, null],
  ["26354", "Killing Floor 3", 128, null],
  ["7998", "Max Payne 3", 128, null],
  ["26316", "Shadowverse: Worlds Beyond", 128, null],
  ["27960", "Crashout Crew", 127, null],
  ["21194", "Friday the 13th The Game", 127, null],
  ["6596", "Assassin's Creed: Brotherhood MP", 126, null],
  ["24466", "Five Nights at Freddy's: Into the Pit", 126, null],
  ["22906", "Shadows of Doubt", 126, null],
  ["27186", "Slots & Daggers", 126, null],
  ["10406", "Watch_Dogs", 126, null],
  ["24544", "Age of Mythology: Retold", 125, null],
  ["22162", "The Mortuary Assistant", 125, null],
  ["23178", "Thronefall", 125, null],
  ["21588", "Total War: Three Kingdoms", 125, null],
  ["25352", "Carry The Glass", 124, null],
  ["21248", "Total War: WARHAMMER II", 124, null],
  ["22288", "Victoria 3", 124, null],
  ["21412", "Crash Bandicoot N. Sane Trilogy", 123, null],
  ["23200", "Labyrinthine", 123, null],
  ["24412", "Nobody Wants to Die", 123, null],
  ["22306", "Soulstone Survivors", 123, null],
  ["7368", "L.A. Noire", 122, null],
  ["22054", "911 Operator", 121, null],
  ["21848", "Diablo 2 Resurrected", 121, null],
  ["7308", "Dungeon Defenders", 121, null],
  ["26412", "Keep on Mining!", 121, null],
  ["24864", "Nuclear Option", 121, null],
  ["23682", "The Exit 8", 121, null],
  ["9982", "The Stanley Parable", 121, null],
  ["9920", "The Wolf Among Us", 121, null],
  ["5501", "Borderlands", 120, null],
  ["22530", "Five Nights at Freddy's: Help Wanted", 120, null],
  ["24606", "Mouthwashing", 120, null],
  ["25330", "Rift of the NecroDancer", 120, null],
  ["23344", "Void Crew", 120, null],
  ["23902", "Big Ambitions", 119, null],
  ["6221", "Blur", 119, null],
  ["23506", "Football Manager 2024", 119, null],
  ["6940", "SEGA Genesis & Mega Drive Classics", 119, null],
  ["23728", "A Date with Death", 118, null],
  ["21924", "FIFA 22", 118, null],
  ["22968", "Kingdoms and Castles", 118, null],
  ["24348", "Oh Deer!", 118, null],
  ["24284", "Soulmask", 118, null],
  ["27456", "A Game About Feeding A Black Hole", 117, null],
  ["13392", "Don't Starve Together", 117, null],
  ["10646", "Far Cry 4", 117, null],
  ["25612", "The First Berserker: Khazan", 117, null],
  ["25180", "Warden's Will", 117, null],
  ["25920", "WWE 2K25", 117, null],
  ["7360", "Call of Duty: Modern Warfare 3 Multiplayer", 116, null],
  ["26942", "Goblin Cleanup", 116, null],
  ["6658", "Lego Star Wars III: The Clone Wars", 116, null],
  ["22578", "Skul", 116, null],
  ["10224", "The LEGO Movie Videogame", 116, null],
  ["23122", "Ultimate Epic Battle Simulator 2", 116, null],
  ["27024", "Unfair Flips", 116, null],
  ["26434", "Wildgate", 116, null],
  ["6760", "Elsword", 115, null],
  ["21288", "Northgard", 115, null],
  ["24840", "Shapez 2", 115, null],
  ["23194", "Armored Core VI: Fires of Rubicon", 114, null],
  ["25930", "Car Dealer Simulator", 114, null],
  ["9497", "Metro: Last Light", 114, null],
  ["7394", "Saints Row: The Third (DX9)", 114, null],
  ["22120", "Shop Titans", 114, null],
  ["21638", "Warcraft 3: Reforged", 114, null],
  ["22992", "F1 23", 113, null],
  ["22128", "Ground Branch", 113, null],
  ["22230", "NBA 2K23", 113, null],
  ["3179", "Call of Duty 4: Modern Warfare Multiplayer", 112, null],
  ["22368", "Coral Island", 112, null],
  ["7380", "Sonic Generations", 112, null],
  ["23022", "Super Bunny Man", 112, null],
  ["28138", "The Mound: Omen of Cthulhu", 112, null],
  ["26458", "A Few Quick Matches", 111, null],
  ["24354", "Bellwright", 111, null],
  ["9232", "BioShock Infinite", 111, null],
  ["23846", "Disfigure", 111, null],
  ["6237", "LEGO Harry Potter Years 1-4", 111, null],
  ["8512", "XCOM: Enemy Unknown", 111, null],
  ["28174", "MARVEL Tokon: Fighting Souls", 110, null],
  ["23206", "The Texas Chainsaw Massacre", 110, null],
  ["24082", "Tomb Raider I-III Remastered Starring Lara Croft", 110, null],
  ["9006", "DmC: Devil May Cry", 109, null],
  ["1829", "Final Fantasy VII", 109, null],
  ["25232", "FINAL FANTASY VII REBIRTH", 109, null],
  ["25928", "Oddsparks: An Automation Adventure", 109, null],
  ["23532", "Risk of Rain Returns", 109, null],
  ["10594", "Styx: Master of Shadows", 109, null],
  ["23762", "Wobbledogs", 109, null],
  ["10864", "Black Desert Online", 108, null],
  ["10784", "LEGO Worlds", 108, null],
  ["6393", "Poker Night at the Inventory", 108, null],
  ["4565", "Saints Row 2", 108, null],
  ["2981", "BioShock", 107, null],
  ["21280", "Spintires: MudRunner", 107, null],
  ["6261", "Alien Swarm", 106, null],
  ["22996", "Amanda the Adventurer", 106, null],
  ["10748", "Infinifactory", 106, null],
  ["24686", "Nodebuster", 106, null],
  ["24768", "Teenage Mutant Ninja Turtles: Splintered Fate", 106, null],
  ["24370", "Until Then", 106, null],
  ["27896", "Heroes of Might and Magic: Olden Era", 105, null],
  ["8670", "Hitman: Sniper Challenge", 105, null],
  ["27490", "My Winter Car", 105, null],
  ["24870", "Pacific Drive", 105, null],
  ["21380", "Ylands", 105, null],
  ["22744", "Deceive Inc.", 104, null],
  ["24324", "Granblue Fantasy: Relink", 104, null],
  ["21560", "Grim Dawn", 104, null],
  ["25192", "Heroes of Hammerwatch II", 104, null],
  ["22562", "Hi-Fi RUSH", 104, null],
  ["25290", "Jotunnslayer: Hordes of Hel", 104, null],
  ["22902", "Poly Bridge 3", 104, null],
  ["21932", "Tiny Tina's Wonderlands", 104, null],
  ["24168", "Sker Ritual", 103, null],
  ["28194", "The Blood of the Dawnwalker", 103, null],
  ["21980", "We Were Here Forever", 103, null],
  ["26538", "Abyssus", 102, null],
  ["24470", "Dungeons & Degenerate Gamblers", 102, null],
  ["10608", "Final Fantasy XIII", 102, null],
  ["24532", "Squirrel With A Gun", 102, null],
  ["23718", "Warhammer 40,000: Rogue Trader", 102, null],
  ["10768", "Zula", 102, null],
  ["22842", "Apewar", 101, null],
  ["23872", "DAVIGO", 101, null],
  ["22742", "Have a Nice Death", 101, null],
  ["23674", "HAWKED", 101, null],
  ["10018", "Injustice: Gods Among Us", 101, null],
  ["22278", "Need for Speed:Hot Pursuit Remastered", 101, null],
  ["8748", "Scribblenauts Unlimited", 101, null],
  ["28090", "Species: Unknown", 101, null],
  ["27272", "The Last Caretaker", 101, null],
  ["24966", "Kindergarten 2", 100, null],
  ["10696", "Trove", 100, null],
  ["21512", "Foxhole", 99, null],
  ["22798", "HavenDock", 99, null],
  ["26496", "Tiny Bookshop", 99, null],
  ["24338", "ASKA", 98, null],
  ["24352", "Rabbit and Steel", 98, null],
  ["25336", "SWORN", 97, null],
  ["25790", "Emissary Zero", 96, null],
  ["23708", "I am Fish", 96, null],
  ["23276", "NBA 2K24", 96, null],
  ["27126", "Superliminal", 96, null],
  ["21330", "Wizard of Legend", 96, null],
  ["28148", "Generation Zero", 95, null],
  ["25452", "PGA TOUR 2K25", 95, null],
  ["22004", "Project Winter", 95, null],
  ["24628", "Recycling Center Simulator", 95, null],
  ["24262", "Voices of the Void", 95, null],
  ["25572", "BLEACH Rebirth of Souls", 94, null],
  ["23684", "Diplomacy is Not an Option", 94, null],
  ["861", "MapleStory", 94, null],
  ["23882", "NARUTO X BORUTO Ultimate Ninja STORM CONNECTIONS", 94, null],
  ["27360", "Side Effects", 94, null],
  ["25222", "There Is No Game: Wrong Dimension", 94, null],
  ["24824", "Lost But Found", 93, null],
  ["7866", "The Walking Dead", 93, null],
  ["10712", "Total War: Attila", 93, null],
  ["23772", "Travellers Rest", 93, null],
  ["22260", "Trombone Champ", 93, null],
  ["28006", "Voidling Bound", 93, null],
  ["6578", "iRacing", 92, null],
  ["10716", "Ori and the Blind Forest", 92, null],
  ["22820", "Cassette Beasts", 91, null],
  ["10412", "Sniper Elite 3", 91, null],
  ["23714", "FINAL FANTASY VII EVER CRISIS", 90, null],
  ["23068", "Gravity Circuit", 90, null],
  ["22880", "Only Up!", 90, null],
  ["26090", "Rooftops & Alleys: The Parkour Game", 90, null],
  ["21900", "Saints Row the Third: Remastered", 90, null],
  ["21376", "FINAL FANTASY XV WINDOWS EDITION", 89, null],
  ["10624", "Heroes of the Storm", 89, null],
  ["22716", "Luck be a Landlord", 89, null],
  ["26614", "METAL GEAR SOLID DELTA: SNAKE EATER", 89, null],
  ["22718", "Transport Fever 2", 89, null],
  ["22840", "Age of Wonders 4", 88, null],
  ["23906", "Drug Dealer Simulator", 88, null],
  ["24836", "Dungeon Clawler", 88, null],
  ["27362", "Incredicer", 88, null],
  ["10686", "Ryse: Son of Rome", 88, null],
  ["23138", "Sticky Business", 88, null],
  ["23918", "Blasphemous 2", 87, null],
  ["24882", "Get To Work", 87, null],
  ["22320", "Naraka: Bladepoint", 87, null],
  ["27990", "Solarpunk", 87, null],
  ["27874", "STALCRAFT:X", 87, null],
  ["6344", "Dead Rising 2", 86, null],
  ["24754", "Dragon Age: The Veilguard", 86, null],
  ["27986", "Fatekeeper", 86, null],
  ["25710", "Into the Dead: Our Darkest Days", 86, null],
  ["6932", "Super Street Fighter IV - Arcade Edition", 86, null],
  ["24806", "Grocery Store Simulator", 85, null],
  ["24968", "I Am Your Beast", 85, null],
  ["27280", "INAZUMA ELEVEN: Victory Road", 85, null],
  ["25802", "Jacksmith: Weapons and Warriors", 85, null],
  ["25370", "Motor Town: Behind The Wheel", 85, null],
  ["23144", "Ratchet and Clank: Rift Apart", 85, null],
  ["27884", "Spiritfarer: Farewell Edition", 85, null],
  ["25464", "Two Point Museum", 85, null],
  ["28066", "Zero Hour", 85, null],
  ["26954", "Deconstruction Simulator", 84, null],
  ["21676", "Loop Hero", 84, null],
  ["10652", "Assassin's Creed: Unity", 83, null],
  ["9206", "Sniper: Ghost Warrior 2", 83, null],
  ["21292", "The Evil Within 2", 83, null],
  ["7972", "Torchlight II", 83, null],
  ["24776", "Windblown", 83, null],
  ["27804", "Cairn", 82, null],
  ["4406", "Call of Duty: World at War Singleplayer", 82, null],
  ["21452", "Deus Ex: Mankind Divided", 82, null],
  ["22330", "Goat Simulator 3", 82, null],
  ["23404", "My Little Universe", 82, null],
  ["10480", "Robocraft", 82, null],
  ["23552", "Slay the Princess", 82, null],
  ["4184", "Warhammer Online: Age of Reckoning", 82, null],
  ["22126", "Wartales", 82, null],
  ["23512", "Attack on Titan 2", 81, null],
  ["26930", "A Gentlemen's Dispute", 80, null],
  ["22292", "Against the Storm", 80, null],
  ["22950", "DorfRomantik", 80, null],
  ["22152", "F1 2022", 80, null],
  ["23158", "Grand Emprise: Time Travel Survival", 80, null],
  ["22020", "Hardspace: Shipbreaker", 80, null],
  ["27336", "Monsters are Coming! Rock & Road", 80, null],
  ["21502", "Punch Club", 80, null],
  ["25750", "Sephiria", 80, null],
  ["21984", "Shotgun King", 80, null],
  ["5960", "Supreme Commander 2", 80, null],
  ["23428", "Wizard With a Gun", 80, null],
  ["22666", "Wo Long: Fallen Dynasty", 80, null],
  ["23262", "BlazBlue: Entropy Effect", 79, null],
  ["10636", "Call of Duty: Advanced Warfare Single Player", 79, null],
  ["23850", "Cat Quest", 79, null],
  ["21458", "Dragon's Dogma: Dark Arisen", 79, null],
  ["25898", "RoadCraft", 79, null],
  ["7430", "AirMech", 78, null],
  ["25850", "Blacksmith Master", 78, null],
  ["21858", "Knockout City", 78, null],
  ["21322", "Vampyr", 78, null],
  ["23278", "Chillquarium", 77, null],
  ["24736", "Magicraft", 77, null],
  ["23636", "Operation Tango", 77, null],
  ["10644", "Risk of Rain", 77, null],
  ["21532", "Soul Calibur VI", 77, null],
  ["23218", "To The Core", 77, null],
  ["23782", "100 Asian Cats", 76, null],
  ["22030", "Alien Swarm: Reactive Drop", 76, null],
  ["25202", "Aloft", 76, null],
  ["23890", "Amazing Frog ? 2", 76, null],
  ["10332", "Banished", 76, null],
  ["25346", "Door Kickers 2", 76, null],
  ["23440", "Fears to Fathom: Ironbark Lookout", 76, null],
  ["6217", "APB: Reloaded", 75, null],
  ["21558", "LEGO MARVEL Super Heroes 2", 75, null],
  ["23132", "My Friendly Neighborhood", 75, null],
  ["22108", "Riftbreaker", 75, null],
  ["6374", "Star Wars: The Force Unleashed 2", 75, null],
  ["24816", "Towers of Aghasba", 75, null],
  ["24638", "Until Dawn", 75, null],
  ["24568", "Fears to Fathom - Woodbury Getaway", 74, null],
  ["10212", "Octodad: Dadliest Catch", 74, null],
  ["26174", "Tower Wizard", 74, null],
  ["22708", "Volcanoids", 74, null],
  ["23730", "WolfQuest: Anniversary Edition", 74, null],
  ["23300", "Arrow a Row", 73, null],
  ["24136", "Incursion: Red River", 73, null],
  ["26996", "Beatblock", 72, null],
  ["23860", "Call to Arms - Gates of Hell: Ostfront", 72, null],
  ["27904", "Gambonanza", 72, null],
  ["26480", "Mafia: The Old Country", 72, null],
  ["23748", "(the) Gnorp Apologue", 71, null],
  ["26450", "Demon Slayer -Kimetsu no Yaiba- The Hikonami Chronicles", 71, null],
  ["24926", "KLETKA", 71, null],
  ["27864", "Lucid Blocks", 71, null],
  ["21534", "Mega Man 11", 71, null],
  ["26452", "Stronghold Crusader: Definitive Edition", 71, null],
  ["10692", "Tales from the Borderlands", 71, null],
  ["22140", "Bear and Breakfast", 70, null],
  ["23426", "Call Of Duty: Modern Warfare 2 (Remastered)", 70, null],
  ["27946", "Farever", 70, null],
  ["23638", "KeyWe", 70, null],
  ["26902", "Life Is Strange: Remastered", 70, null],
  ["22238", "Metal: Hellsinger", 70, null],
  ["595", "Psychonauts", 70, null],
  ["487", "Star Wars Republic Commando", 70, null],
  ["21822", "Tribes of Midgard", 70, null],
  ["27726", "Caravan Sandwitch", 69, null],
  ["24612", "Dungeon Tycoon", 69, null],
  ["23632", "Hammerwatch II", 69, null],
  ["21232", "Nioh", 69, null],
  ["26130", "Parcel Simulator", 69, null],
  ["22588", "Retail Royale", 69, null],
  ["26442", "The King Is Watching", 69, null],
  ["21274", "They Are Billions", 69, null],
  ["22180", "Way of the Hunter", 69, null],
  ["24522", "Beyond All Reason", 68, null],
  ["22008", "Darkest Dungeon 2", 68, null],
  ["21362", "Gloria Victis", 68, null],
  ["24954", "Katana ZERO", 68, null],
  ["24080", "Lightyear Frontier", 68, null],
  ["27372", "MARVEL Cosmic Invasion", 68, null],
  ["23046", "Outward: Definitive Edition", 68, null],
  ["27614", "Rising Front", 68, null],
  ["23098", "Smalland", 68, null],
  ["24546", "Star Trucker", 68, null],
  ["24334", "Still Wakes the Deep", 68, null],
  ["21456", "Street Fighter V", 68, null],
  ["27468", "Bits & Bops", 67, null],
  ["22074", "Bugsnax", 67, null],
  ["23600", "Death must Die", 67, null],
  ["24950", "Digseum", 67, null],
  ["26962", "Easy Delivery Co.", 67, null],
  ["21964", "Ember Knights", 67, null],
  ["23468", "Hero Siege", 67, null],
  ["23082", "Nova Lands", 67, null],
  ["25152", "OUTBRK", 67, null],
  ["23120", "Techtonica", 67, null],
  ["27104", "Absolum", 66, null],
  ["26984", "Aethermancer", 66, null],
  ["25372", "Avowed", 66, null],
  ["1670", "Call of Duty 2", 66, null],
  ["26878", "Coal LLC", 66, null],
  ["25420", "Die in the Dungeon", 66, null],
  ["23044", "Halls of Torment", 66, null],
  ["23030", "Rhythm Doctor", 66, null],
  ["24246", "Rusty's Retirement", 66, null],
  ["24688", "The Forever Winter", 66, null],
  ["27164", "Bookshop Simulator", 65, null],
  ["25378", "Caliber", 65, null],
  ["10704", "H1Z1", 65, null],
  ["23716", "UNDYING", 65, null],
  ["22116", "As Dusk Falls", 64, null],
  ["23690", "Blood West", 64, null],
  ["16248", "Men of War: Assault Squad 2", 64, null],
  ["27270", "Restaurats", 64, null],
  ["22534", "Shakes and Fidget", 64, null],
  ["24378", "Ship Graveyard Simulator 2", 64, null],
  ["25594", "Wreckfest 2", 64, null],
  ["24828", "Feign", 63, null],
  ["28008", "Gothic 1 Remake", 63, null],
  ["9026", "Sonic and Sega All-Star Racing Transformed", 63, null],
  ["26546", "Whisper Mountain Outbreak", 63, null],
  ["22428", "Antimatter Dimensions", 62, null],
  ["9130", "Brutal Legend", 62, null],
  ["26088", "Cast n Chill", 62, null],
  ["6568", "Dragon Age II", 62, null],
  ["1925", "Dungeons & Dragons Online: Eberron Unlimited", 62, null],
  ["22168", "Farthest Frontier", 62, null],
  ["27876", "Going Medieval", 62, null],
  ["26494", "GUNTOUCHABLES", 62, null],
  ["26900", "Life Is Strange: Before the Storm", 62, null],
  ["21240", "PLAYERUNKNOWN'S BATTLEGROUNDS (Test Server)", 62, null],
  ["21250", "Shadowverse", 62, null],
  ["24018", "The Universim", 62, null],
  ["22264", "The Wandering Village", 62, null],
  ["26454", "Twisted Gallery", 62, null],
  ["9866", "Battlefield 4", 61, null],
  ["10878", "Battlerite", 61, null],
  ["26186", "Broken Arrow", 61, null],
  ["26040", "Granny: Escape Together", 61, null],
  ["25506", "ORDER 13", 61, null],
  ["22336", "Ship of Fools", 61, null],
  ["23350", "Supraland", 61, null],
  ["26142", "Tobacco Shop Simulator", 61, null],
  ["25298", "Unrailed 2: Back On Track", 61, null],
  ["24046", "WWE 2K24", 61, null],
  ["23892", "Animal Shelter Simulator", 60, null],
  ["26594", "BACKROOMS: APPREHENSION", 60, null],
  ["27912", "MOTORSLICE", 60, null],
  ["22036", "My Time at Sandrock", 60, null],
  ["23492", "RoboCop Rogue City", 60, null],
  ["24346", "SUPERVIVE", 60, null],
  ["22266", "Across the Obelisk", 59, null],
  ["22640", "Company of Heroes 3", 59, null],
  ["10782", "Magicka 2", 59, null],
  ["7306", "Payday: The Heist", 59, null],
  ["7636", "Rayman Origins", 59, null],
  ["24508", "Galaxy Burger", 58, null],
  ["22540", "KartRider: Drift", 58, null],
  ["26806", "Lawn Mowing Simulator", 58, null],
  ["7392", "LEGO Harry Potter Years 5-7", 58, null],
  ["27416", "Nine-Ball Roulette", 58, null],
  ["23184", "Sengoku Dynasty", 58, null],
  ["24598", "Slackers - Carts of Glory", 58, null],
  ["22310", "The Past Within", 58, null],
  ["26282", "Backyard Baseball '01", 57, null],
  ["24310", "Creeper World 4", 57, null],
  ["4492", "Cross Fire EU", 57, null],
  ["4289", "Dead Space (2008)", 57, null],
  ["22552", "FCT", 57, null],
  ["27922", "Flock Around", 57, null],
  ["27842", "Mall Simulator", 57, null],
  ["23018", "Six days in fallujah", 57, null],
  ["25804", "The Precinct", 57, null],
  ["25788", "Tower Dominion", 57, null],
  ["26436", "WUCHANG: Fallen Feathers", 57, null],
  ["26400", "Animal Shelter 2", 56, null],
  ["11848", "Bejeweled 3", 56, null],
  ["27740", "Bladesong", 56, null],
  ["10638", "Call of Duty: Advanced Warfare Multi Player", 56, null],
  ["24850", "ContractVille", 56, null],
  ["22208", "Destroy All Humans! 2 - Reprobed", 56, null],
  ["27322", "Egging On", 56, null],
  ["22214", "Ghost Watchers", 56, null],
  ["24714", "Rivals of Aether II", 56, null],
  ["22664", "The Ouroboros King", 56, null],
  ["26558", "Waltz of the Wizard Extended Edition", 56, null],
  ["23304", "Yet Another Zombie Survivors", 56, null],
  ["24902", "Ballionaire", 55, null],
  ["10670", "Elite: Dangerous", 55, null],
  ["25304", "Fantasy Map Simulator", 55, null],
  ["26102", "FBC: Firebreak", 55, null],
  ["24214", "FOUNDRY", 55, null],
  ["24586", "Frostpunk 2", 55, null],
  ["27806", "HELLMART", 55, null],
  ["27342", "Moonlighter 2: The Endless Vault", 55, null],
  ["24416", "Norland", 55, null],
  ["27442", "Outhold", 55, null],
  ["26224", "Primordialis", 55, null],
  ["22870", "Starship Troopers: Extermination", 55, null],
  ["22912", "Super Mega Baseball 4", 55, null],
  ["25308", "TemTem: Swarm", 55, null],
  ["27868", "The Artisan of Glimmith", 55, null],
  ["26164", "Tiny Aquarium", 55, null],
  ["10410", "Train Simulator 2014", 55, null],
  ["22866", "Warhammer 40K: Boltgun", 55, null],
  ["7966", "Alan Wake's American Nightmare", 54, null],
  ["23360", "Atlas Fallen", 54, null],
  ["22050", "Diablo Immortal", 54, null],
  ["23694", "Die in the Dungeon: Origins", 54, null],
  ["27254", "Europa Universalis V", 54, null],
  ["27196", "GODBREAKERS", 54, null],
  ["24322", "Granblue Fantasy Versus: Rising", 54, null],
  ["24358", "Gunsmith Simulator", 54, null],
  ["26876", "Keep Digging", 54, null],
  ["17002", "OpenTTD", 54, null],
  ["21972", "Warpips", 54, null],
  ["24694", "Amanda The Adventurer 2", 53, null],
  ["23202", "Bomb Rush Cyberfunk", 53, null],
  ["10736", "DragonBall XenoVerse", 53, null],
  ["28102", "Fishing Inc", 53, null],
  ["25206", "Hyper Light Drifter", 53, null],
  ["9198", "Insurgency 2014", 53, null],
  ["25006", "Laundry Store Simulator", 53, null],
  ["6269", "Mafia II", 53, null],
  ["24024", "Minami Lane", 53, null],
  ["24040", "Outpath", 53, null],
  ["24910", "The Cabin Factory", 53, null],
  ["24674", "A Quiet Place: The Road Ahead", 52, null],
  ["21290", "Battle Brothers", 52, null],
  ["22344", "Cosmoteer", 52, null],
  ["22382", "Divine Knockout", 52, null],
  ["27548", "Drifter Star: Evolution", 52, null],
  ["24336", "Drug Dealer Simulator 2", 52, null],
  ["23168", "Fabledom", 52, null],
  ["25274", "FlyKnight", 52, null],
  ["28166", "Guildrun", 52, null],
  ["25952", "JDM: Japanese Drift Master", 52, null],
  ["26468", "Kindergarten 3", 52, null],
  ["10828", "Kingdom Rush", 52, null],
  ["21228", "Quake Champions", 52, null],
  ["26860", "Star Birds", 52, null],
  ["26910", "Town To City", 52, null],
  ["28160", "We were Here Too", 52, null],
  ["27446", "Alchemy Factory", 51, null],
  ["21346", "Bless Online", 51, null],
  ["26852", "Firefighting Simulator: Ignite", 51, null],
  ["26414", "Gatekeeper", 51, null],
  ["27952", "Ghostrunner", 51, null],
  ["22586", "MADDEN 23", 51, null],
  ["25904", "Monster Train 2", 51, null],
  ["21520", "Portal Knights", 51, null],
  ["9798", "Rogue Legacy", 51, null],
  ["21868", "Titanfall 2: Northstar", 51, null],
  ["23062", "A Plaguetale: Requiem", 50, null],
  ["28168", "Corsair Cove", 50, null],
  ["23790", "Dead Estate", 50, null],
  ["7320", "Dead Rising 2: Off The Record", 50, null],
  ["26444", "He Is Coming", 50, null],
  ["10626", "Lords of the Fallen", 50, null],
  ["9938", "NARUTO SHIPPUDEN: Ultimate Ninja STORM 3", 50, null],
  ["22976", "Necesse", 50, null],
  ["28064", "Nioh 3", 50, null],
  ["26342", "Surfs Up", 50, null],
  ["23214", "Teenage Mutant Ninja Turtles: Shredder's Revenge", 50, null],
  ["22622", "WILD HEARTS", 50, null],
  ["23038", "Yakuza: Like A Dragon", 50, null],
  ["21650", "Fall Guys", null, "cannot deliver: the client routes this title to its event-based path"],
  [
    "28164",
    "Teamfight Tactics",
    null,
    "deliverable, but Overwolf cannot separate it from TFT PBE (28162): count and launch attribution are shared",
  ],
  ["28162", "Teamfight Tactics PBE", null, "install count shared with Teamfight Tactics"],
  ["22904", "VALORANT PBE", null, "install count shared with VALORANT"],
]
